import React from 'react';
import Slider from '../../Slider';
import WidgetRow from '../WidgetRow';

interface Props {
  x: number;
  y: number;
  onXChange: (val: number) => void;
  onYChange: (val: number) => void;
}

const MIN = -500;
const MAX = 500;
const STEP = 1;

function WidgetRowOffset({ x, y, onXChange, onYChange }: Props) {
  return (
    <WidgetRow>
      <Slider value={x} min={MIN} max={MAX} onChange={onXChange}>
        <Slider.Header title="水平位置偏移：" />
        <Slider.Bar step={STEP} />
        <Slider.Control step={STEP} />
      </Slider>
      <Slider
        className="mt-20"
        value={y}
        min={MIN}
        max={MAX}
        onChange={onYChange}
      >
        <Slider.Header title="垂直位置偏移：" />
        <Slider.Bar step={STEP} />
        <Slider.Control step={STEP} />
      </Slider>
    </WidgetRow>
  );
}

export default WidgetRowOffset;
